var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.0415 7.875V18.875C26.0415 20.6984 25.3172 22.447 24.0279 23.7364C22.7385 25.0257 20.9899 25.75 19.1665 25.75H8.1665C6.34314 25.75 4.59446 25.0257 3.30514 23.7364C2.01583 22.447 1.2915 20.6984 1.2915 18.875V7.875C1.2915 6.05164 2.01583 4.30295 3.30514 3.01364C4.59446 1.72433 6.34314 1 8.1665 1H19.1665C20.9899 1 22.7385 1.72433 24.0279 3.01364C25.3172 4.30295 26.0415 6.05164 26.0415 7.875Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 31",
    d: "M14.8689 12.9281H15.272L19.2916 8.05176H18.8884L14.8689 12.9281Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.453609
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 33",
    d: "M9.08521 19.6186H9.447L13.0543 15.0825H12.6925L9.08521 19.6186Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.453609
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 32",
    d: "M19.2632 19.2503H15.9745L8.2915 8.05176H11.5802L19.2632 19.2503Z",
    stroke: "white",
    strokeWidth: 1.13402
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5d7afd0a4628d3e5188d1864da8f01d4.svg";
export { ForwardRef as ReactComponent };